import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["content"]

  insert() {
    const content = this.contentTarget.getAttribute('data-html')
    if (!content) return

    // Try Tiptap first, then Medium Editor
    if (window.tiptapEditor) {
      window.tiptapEditor.chain().focus().insertContent(content).run()
      if (window._syncAndSaveEditor) window._syncAndSaveEditor()
    } else {
      const editorField = document.querySelector('.editable')
      if (!editorField) return

      const MediumEditor = window.MediumEditor
      const editor = MediumEditor ? MediumEditor.getEditorFromElement(editorField) : null
      const selection = window.getSelection()
      const isInsideEditor = editorField.contains(selection.anchorNode)

      if (editor && isInsideEditor && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0)
        range.deleteContents()
        range.insertNode(range.createContextualFragment(content))
        range.collapse(false)
        editor.trigger('editableInput', null, editor.elements[0])
      } else if (editor) {
        editorField.innerHTML += content
        editor.trigger('editableInput', null, editor.elements[0])
      } else {
        editorField.innerHTML += content
      }

      if (window._syncAndSaveEditor) {
        window._syncAndSaveEditor(editorField, editor)
      } else {
        document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }))
      }
    }

    // Flash confirmation
    const btn = this.element
    const originalHTML = btn.innerHTML
    btn.innerHTML = '<span class="fas fa-check mr-1"></span>Inserted'
    btn.classList.add('opacity-7')
    setTimeout(() => {
      btn.innerHTML = originalHTML
      btn.classList.remove('opacity-7')
    }, 2000)
  }
}
